module.exports = __webpack_public_path__ + "img/image 23.fe0017ac.png";